import React from 'react';
import { useLocation } from 'react-router-dom';
import { Error as ErrorIcon } from '@mui/icons-material';
import { ListItemText, Tooltip } from '@mui/material';

import useIsScreenerAllFacilitiesSelected, {
  SCREENER_ROUTES_WITH_ALL_FACILITIES_SUPPORT
} from '@/pages/CRM/Screener/Leads/AllLeads/hooks/useIsScreenerAllFacilitiesSelected';
import useNavigateToScreenerAllFacilities from '@/pages/CRM/Screener/Leads/AllLeads/hooks/useNavigateToScreenerAllFacilitites';
import { RoutePath } from '@/routes/RoutePath';

import { FacilitySelectorListItemButton } from './FacilitySelectorPopover';

interface CrmScreenerSelectAllButtonProps {
  setIsOpen: (value: React.SetStateAction<boolean>) => void;
  hide: boolean;
  anyFacilityBillingDisabled: boolean;
}

export default function CrmScreenerSelectAllButton(
  props: CrmScreenerSelectAllButtonProps
) {
  const { hide = false, setIsOpen, anyFacilityBillingDisabled } = props;
  const location = useLocation();
  const shouldShowSelectAllButton =
    SCREENER_ROUTES_WITH_ALL_FACILITIES_SUPPORT.includes(
      location.pathname as RoutePath
    );
  const isAllFacilitiesSelected = useIsScreenerAllFacilitiesSelected();
  const navigateToScreenerAllFacilities = useNavigateToScreenerAllFacilities(
    location.pathname as RoutePath
  );

  if (!shouldShowSelectAllButton || hide) {
    return null;
  }

  return (
    <FacilitySelectorListItemButton
      role="option"
      selected={isAllFacilitiesSelected}
      disabled={anyFacilityBillingDisabled}
      onClick={() => {
        navigateToScreenerAllFacilities();
        setIsOpen(false);
      }}
      sx={anyFacilityBillingDisabled ? { opacity: 0.5 } : undefined}
    >
      <ListItemText>Select All</ListItemText>
      {anyFacilityBillingDisabled && (
        <Tooltip
          title="All Facilities view is disabled due to an unpaid balance on one or more facilities."
          placement="top"
        >
          <ErrorIcon
            sx={{
              fontSize: 18,
              color: '#D32F2F !important',
              ml: 1,
              pointerEvents: 'auto'
            }}
          />
        </Tooltip>
      )}
    </FacilitySelectorListItemButton>
  );
}
